import { DocumentDetailsSheet } from './document-details-sheet';

import { useKnowledgeModalsStore } from '@/store/knowledge-modals.store';

export function DocumentDetailsSheetContainer() {
  const isOpen = useKnowledgeModalsStore(state => state.isDocumentDetailsOpen);
  const filePath = useKnowledgeModalsStore(state => state.selectedDocument);
  const closeDocumentDetails = useKnowledgeModalsStore(state => state.closeDocumentDetails);

  if (!isOpen) return null;

  return (
    <DocumentDetailsSheet filePath={filePath} isOpen={isOpen} onClose={closeDocumentDetails} />
  );
}
